<template>
  <div class="main-row">
    <div class="left-column">
      <div class="infobox">
        <h4>Steg 2 av 2</h4>
        <br>
        <p>
          Bare litt igjen nå!<br>
          Estimatene i denne kalkulatoren er basert på SSBs lønnsdata for ingeniører og modeller for lønnsutvikling etter ansienitet.
        </p>
      </div>
    </div>
    <div class="right-column">
      <v-form v-model="valid" class="form">
        <v-radio-group v-model="user.siving" row centered>
          <v-radio label="Jeg er ingeniør" :value="false"></v-radio>
          <v-radio label="Jeg er sivilingeniør" :value="true"></v-radio>
        </v-radio-group>
        <span class="fagfelt">
          <v-select
              attach=".fagfelt"
              :items="ifSiving"
              v-model="user.field"
              :rules="rules.required"
              placeholder="Ditt fagfelt"
              prepend-icon="work"
              required
          ></v-select>
        </span>
        <span class="counties">
          <v-select
              attach=".counties"
              v-model="user.county"
              :items="counties"
              :rules="rules.required"
              placeholder="Ditt fylke"
              prepend-icon="location_city"
              required
          ></v-select>
        </span>
        <v-checkbox
          v-model="user.public_sector"
          :label="`Jeg jobber i offentlig sektor`"
        ></v-checkbox>
      <br><v-btn :loading="loading" :disabled="!valid" @click="submitForm" block color="primary">Se resultat<v-icon>navigate_next</v-icon></v-btn><br><br><br>
      </v-form>
    </div>
  </div>
</template>

<script>
  export default {
    props: { 
      user: Object,
      db: Object 
    },
    data: () => ({
      siving: false,
      valid: true,
      loading: false,
      rules: {
        required: [ 
          val => !!val || 'Denne må fylles ut' 
        ]
      },
      counties: [
        "Østfold",
        "Akershus",
        "Oslo",
        "Hedmark",
        "Oppland",
        "Buskerud",
        "Vestfold",
        "Telemark",
        "Aust-Agder",
        "Vest-Agder",
        "Rogaland",
        "Hordaland",
        "Sogn og Fjordane",
        "Møre og Romsdal",
        "Trøndelag",
        "Nordland",
        "Troms",
        "Finnmark"
      ],
      field_options_siving: [
        'Industri og produksjon',
        'Bygg og anlegg',
        'Maskin- og marinteknikk',
        'Kjemi',
        'Geofag, petroleum, metallurgi',
        'Elkraftteknikk',
        'Elektronikk',
        'Telekommunikasjon',
        'Andre sivilingeniører',
      ],
      field_options_ing: [
        'Bygningsingeniør',
        'Elkraftingeniør',
        'Elektronikkingeniør',
        'Maskiningeniør',
        'Kjemiingeniør',
        'Petroleum, bergverk og metallurgi',
        'Tekniske tegnere',
        'Bioingeniører',
        'Andre ingeniører',
      ],
      salaryRules: [
        v => !!v || 'E-mail is required',
      ]
    }),
    methods: {
      submitForm() {
        this.user.created_at = new Date()
        this.loading = true
        //Create the user document
        this.db.collection('users').doc(this.user.user_id).set(this.user)
        //Listen for changes to the user document
        this.db.collection('users').doc(this.user.user_id)
          .onSnapshot((doc) => {
            let data = doc.data()
            //An expected salary means the cloud function calculation has finished. 
            if(data && data.expected_salary > 0) {
              this.user.expected_salary = data.expected_salary
              //We want to make a copy of the first entry each user makes. The following checks if a document already exists, and adds it if it does not.
              const first_entry = this.db.collection('first_entries').doc(this.user.user_id)
              first_entry.get()
                .then((docSnapshot) => {
                  if (!docSnapshot.exists) {
                    this.db.collection('first_entries').doc(this.user.user_id).set(this.user)
                  } 
              })
            } 
          })
      } 
    },
    computed: {
      ifSiving(){
        if(this.user.siving){
          return this.field_options_siving
        }
        return this.field_options_ing
      }
    }
    
  }
</script>

<style lang="scss">

.digi-kalk {
  //Dirty fix to make the dropdown position work when app is embedded
  .v-menu__content {
    top: auto !important;
    left: auto !important;
    margin-left: 33px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FormFinal.vue